__turbopack_context__.v({
  "modalContainer": "AboutThisEventModal-module-scss-module__-cTieW__modalContainer",
  "modulesWrapper": "AboutThisEventModal-module-scss-module__-cTieW__modulesWrapper",
});
